import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  categoryName: string;
  author: string;
  date: string;
  readTime: number;
  imageUrl: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  categoryName,
  author,
  date,
  readTime,
  imageUrl,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer transition-all duration-300 hover:border-background-300/60">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute top-3 left-3">
            <span className="px-2.5 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-md">
              {categoryName}
            </span>
          </div>
        </div>
        <div className="p-4 md:p-5">
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
            {title}
          </h3>
          <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
            {excerpt}
          </p>
          <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-user-line"></i>
              {author}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {readTime} 分钟阅读
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}